module.exports = __webpack_public_path__ + "static/img/mappa.d767a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mappa.png
// module id = zo1u
// module chunks = 0